module.exports = __webpack_public_path__ + "media/images/vod_icons/clubpilates-b19473e233f5b50f97baac96fd55f1c5.svg";